import { Navigate } from "react-router";
import { paths } from "@shared-core/routing/routes";
import { useCompanySummary } from "./CompanySummaryContext";
import { useSupplierSession } from "./session";
import { LoadingCard } from "./states";

/**
 * Where `/` goes once signed in: Orders; Picks for a supplier that runs a warehouse for us and has no order waiting
 * to be accepted (spec 14 §8.2: a warehouse operator lands on its picks); the assessment form for a new supplier with
 * one to complete and no order waiting. That last is how an accepted portal invite reaches the assessment: the
 * sign-in's *Go to the portal* returns to `/`, and sign-in knows nothing of assessments, so the landing asks Your
 * company's own summary (portal sign-in coordinator, 3 Nov).
 */
export function SignedInIndex() {
  const session = useSupplierSession()?.session;
  const { summary, isLoading } = useCompanySummary();
  const runsAWarehouse = (session?.warehouses.length ?? 0) > 0;
  const ordersWaiting = session?.waiting.orders_to_accept ?? 0;
  // Wait for the summary, so a new supplier is not shown its orders for a moment first.
  if (isLoading && !summary) return <LoadingCard what="your account" />;
  if (summary?.assessment_to_complete && ordersWaiting === 0)
    return <Navigate to={paths.supplierAssessment()} replace />;
  if (runsAWarehouse && ordersWaiting === 0)
    return <Navigate to={paths.supplierPicks()} replace />;
  return <Navigate to={paths.supplierOrders()} replace />;
}
